<template lang="jade">
  tr
    td.group(v-for="(group, gindex) in row.groups")
      .digit(:class="{to_verify: toVerify(group[0]), anim_blur: animBlur(group[0])}")
        input-digit(:ref="group[0].id", :digit="group[0]", :position="[rindex, (0 + (gindex * 4))]", :onChangeFocus="onChangeFocus",
        @focusAutoComplete="focusAutoComplete")
      .digit(:class="{to_verify: toVerify(group[1]), anim_blur: animBlur(group[1])}")
        input-digit(:ref="group[1].id", :digit="group[1]", :position="[rindex, (1 + (gindex * 4))]", :onChangeFocus="onChangeFocus",
        @focusAutoComplete="focusAutoComplete")
      .dots.center-element :
      .digit(:class="{to_verify: toVerify(group[2]), anim_blur: animBlur(group[2])}")
        input-digit(:ref="group[2].id", :digit="group[2]", :position="[rindex, (2 + (gindex * 4))]", :onChangeFocus="onChangeFocus",
        @focusAutoComplete="focusAutoComplete")
      .digit(:class="{to_verify: toVerify(group[3]), anim_blur: animBlur(group[3])}")
        input-digit(:ref="group[3].id", :digit="group[3]", :position="[rindex, (3 + (gindex * 4))]", :onChangeFocus="onChangeFocus",
        @focusAutoComplete="focusAutoComplete")

</template>

<script>
import InputDigit from './InputDigit.vue'
import DayJourney from '../common/DayJourney.vue'

export default {
  props: ['row', 'rindex', 'onChangeFocus'],
  components: {
    InputDigit, DayJourney
  },
  computed: {
    currentDigitId () {
      return this.$store.getters.currentDigit.id
    }
  },
  methods: {
    toVerify (digit) {
      return digit.verify
    },
    animBlur (digit) {
      return digit.animBlur
    },
    focusAutoComplete () {
      this.$emit('focusAutoComplete')
    }
  }
}
</script>

<style scoped>
  .digit {
    width: 22%;
    float: left;
    /*padding: 1px 2px 1px 2px;*/
  }

  .dots {
    width: 4%;
    height: 100%;
    float: left;
  }

  .input-digit {
    width: 100%;
    height: 100%;
  }

  .td-row-wrong {
    width: 7%;
    padding-left: 12px;
  }

  .td-row-wrong button {
    width: 100%;
    padding-left: 12px;
  }
  ::selection {
    color: white;
    background: rgb(200, 200, 200);
  }
  ::-moz-selection {
    color: white;
    background: rgb(200, 200, 200);
  }

  .to_verify {
    background-color: rgba(255, 70, 70, 0.1);
    margin-top: 1px;
  }
</style>



// WEBPACK FOOTER //
// InputSheet.vue?723e0d34